import { object, string, boolean } from 'yup';
import addAtLeastOneNormalCharacter from '@afosto/utils-react/validators/atLeastOneNormalCharacter';

addAtLeastOneNormalCharacter();

export const addColumnValidationSchema = object().shape({
  name: string().atLeastOneNormalCharacter().required(),
  formula: string().required(),
});

export const saveViewValidationSchema = object().shape({
  name: string().atLeastOneNormalCharacter().required(),
  saveViewForTenant: boolean(),
});
